export default {
  SMS: "sms",
  MAIL: "mail",
  NET: "net",
  IOT: "iot"
};
